import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';
import Const from 'constants';
import {rangeOfNumbers} from 'helpers/array-helper';

class PlayersQuantity extends Component {
    onChange(playersQuantity) {
        const {groupNumber} = this.props;
        this.props.dispatch(Action.set('PlayersQuantityForGroupNumber', playersQuantity, groupNumber));
    }

    render() {
        const {groupNumber, stacking} = this.props;
        const quantity = stacking.getPlayersQuantityByGroupNumber(groupNumber);

        const range = rangeOfNumbers(
            Const.RANDOM_TEAM_STACKING_MIN_PLAYERS_QUANTITY,
            Const.RANDOM_TEAM_STACKING_MAX_PLAYERS_QUANTITY,
        );

        return (
            <select
                value={quantity}
                onChange={(e) => ::this.onChange(e.target.value)}
                className="form-control input-sm"
            >
                {range.map((item) => {
                    return (
                        <option key={item} value={item}>
                            {item}
                        </option>
                    );
                })}
            </select>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, randomTeamStacking} = state;
    return {
        sportConfig,
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(PlayersQuantity);
